import { render, staticRenderFns } from "./BloodTypeInfo.vue?vue&type=template&id=507a7c6c&"
import script from "./BloodTypeInfo.vue?vue&type=script&lang=js&"
export * from "./BloodTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports